"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUser = exports.deleteUserError = exports.deleteUserSuccess = exports.closeDeleteUserAlert = exports.openDeleteUserAlert = exports.closeUserToast = exports.openUserToast = exports.setUserToBeEdited = exports.onCloseEditUserModal = exports.onOpenEditUserModal = exports.openCreateUserModal = exports.closeCreateUserModal = exports.saveChanges = exports.saveChangesSuccess = exports.saveChangesError = exports.setFilteredUsers = exports.getUsers = exports.getUsersSuccess = exports.getUsersError = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    users: [],
    areUsersLoading: false,
    hasErrorLoadingUsers: false,
    hasFinishedLoadingUsers: false,
    filteredUsers: [],
    isSavingChanges: false,
    changesSavedSuccess: false,
    hasErrorSavingChanges: false,
    isCreateUserModalOpen: false,
    isEditUserModalOpen: false,
    userToBeEdited: null,
    usersToastStatus: { isOpen: false, message: "", status: undefined },
    isDeleting: false,
    isDeleteAlertDialogOpen: false,
    hasDeletionError: false,
    userToBeDeleted: null,
    errorMessage: "",
};
const usersSlice = (0, toolkit_1.createSlice)({
    name: "users",
    initialState,
    reducers: {
        getUsers: (state) => {
            state.areUsersLoading = true;
        },
        getUsersSuccess: (state, action) => {
            state.areUsersLoading = false;
            state.users = action.payload;
            state.filteredUsers = action.payload;
        },
        getUsersError: (state) => {
            state.hasErrorLoadingUsers = true;
        },
        setFilteredUsers: (state, action) => {
            state.filteredUsers = action.payload;
        },
        saveChanges: (state) => {
            state.isSavingChanges = true;
        },
        saveChangesSuccess: (state) => {
            state.isSavingChanges = false;
            state.changesSavedSuccess = true;
            state.hasErrorSavingChanges = false;
        },
        saveChangesError: (state) => {
            state.changesSavedSuccess = false;
            state.hasErrorSavingChanges = true;
            state.isSavingChanges = false;
        },
        openCreateUserModal: (state) => {
            state.isCreateUserModalOpen = true;
        },
        closeCreateUserModal: (state) => {
            state.isCreateUserModalOpen = false;
        },
        onOpenEditUserModal: (state) => {
            state.isEditUserModalOpen = true;
        },
        onCloseEditUserModal: (state) => {
            state.isEditUserModalOpen = false;
        },
        setUserToBeEdited: (state, action) => {
            state.userToBeEdited = action.payload;
        },
        openUserToast: (state, action) => {
            state.usersToastStatus.status = action.payload.status;
            state.usersToastStatus.message = action.payload.message;
            state.usersToastStatus.isOpen = true;
        },
        closeUserToast: (state) => {
            state.usersToastStatus.isOpen = false;
            state.usersToastStatus.status = undefined;
            state.usersToastStatus.message = "";
        },
        openDeleteUserAlert: (state, action) => {
            state.isDeleteAlertDialogOpen = true;
            state.userToBeDeleted = action.payload.userToBeDeleted;
        },
        closeDeleteUserAlert: (state) => {
            state.isDeleteAlertDialogOpen = false;
            state.userToBeDeleted = null;
            state.errorMessage = "";
        },
        deleteUser: (state) => {
            state.isDeleting = true;
        },
        deleteUserSuccess: (state, action) => {
            state.isDeleting = false;
            state.isDeleteAlertDialogOpen = false;
            state.userToBeDeleted = null;
            state.hasDeletionError = false;
            state.errorMessage = "";
            const updatedUsers = state.filteredUsers.filter((user) => user.id !== action.payload);
            state.filteredUsers = updatedUsers;
        },
        deleteUserError: (state, action) => {
            state.isDeleting = false;
            state.hasDeletionError = true;
            state.errorMessage = action.payload;
        },
    },
});
_a = usersSlice.actions, exports.getUsersError = _a.getUsersError, exports.getUsersSuccess = _a.getUsersSuccess, exports.getUsers = _a.getUsers, exports.setFilteredUsers = _a.setFilteredUsers, exports.saveChangesError = _a.saveChangesError, exports.saveChangesSuccess = _a.saveChangesSuccess, exports.saveChanges = _a.saveChanges, exports.closeCreateUserModal = _a.closeCreateUserModal, exports.openCreateUserModal = _a.openCreateUserModal, exports.onOpenEditUserModal = _a.onOpenEditUserModal, exports.onCloseEditUserModal = _a.onCloseEditUserModal, exports.setUserToBeEdited = _a.setUserToBeEdited, exports.openUserToast = _a.openUserToast, exports.closeUserToast = _a.closeUserToast, exports.openDeleteUserAlert = _a.openDeleteUserAlert, exports.closeDeleteUserAlert = _a.closeDeleteUserAlert, exports.deleteUserSuccess = _a.deleteUserSuccess, exports.deleteUserError = _a.deleteUserError, exports.deleteUser = _a.deleteUser;
exports.default = usersSlice.reducer;
